// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img[disabled][data-v-25bf332a] {\n  /* Safari 6.0 - 9.0 */\n  filter: grayscale(100%);\n}\n.panel-body[data-v-25bf332a] {\n  overflow-y: scroll;\n  max-height: calc(100vh - 250px);\n}", ""]);
// Exports
module.exports = exports;
